import React from 'react';
import { CloseCircleOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { Box, Flex } from 'atoms';

export default function FilterTitle({ title, onClose }) {
	console.log(title);
	return (
		<Flex justifyContent="space-between">
			<Box fontSize="1.5rem" fontWeight="700" color="#091744">
				{title}
			</Box>
			<Box onClick={onClose} color="red" fontWeight="bolder" fontSize="20px" cursor="pointer">
				<CloseCircleOutlined />
			</Box>
		</Flex>
	);
}

FilterTitle.propTypes = {
	onClose: PropTypes.func,
	title: PropTypes.string,
};
